'use strict';

exports.__esModule = true;
exports.default = {
  UPDATE_MATCH: '@@found/UPDATE_MATCH',
  RESOLVE_MATCH: '@@found/RESOLVE_MATCH'
};
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./~/found/lib/ActionTypes.js